import { IInboxMessage, IOutboxMessage } from "../message";

export const CONNECTION_MISSING_ERROR_MESSAGE = "Widget connection is missing";
export const POSTMESSAGE_UNAVAILABLE_ERROR_MESSAGE = "Iframe or postMessage mechanism is unavailable";

export interface IInboxMessageSubscriber {
  (inboxMessage: IInboxMessage, connectionId: string): void;
}

export interface IConnection {
  connectionId: string;
  initialize(): void;
  subscribe(subscriber: IInboxMessageSubscriber): void;
  unsubscribe(subscriber: IInboxMessageSubscriber): void;
  send(message: IOutboxMessage): Promise<void>;
  destroy(): void;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setContext(context: any): void;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getContext(): any;
}
